import React from "react";
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { TrendingUp } from "lucide-react";

// Chart axis styling — module-scoped to avoid re-allocating per render.
const GRID_STROKE = "#e5d9c9";
const AXIS_TICK_STYLE = { fontSize: 11, fill: "#6E7A75" };
const Y_TICKS = [0, 25, 50, 75, 100];
const Y_DOMAIN = [0, 100];
const LINE_MARGIN = { top: 8, right: 16, left: -16, bottom: 0 };
const TOOLTIP_STYLE = { borderRadius: 12, border: `1px solid ${GRID_STROKE}`, fontSize: 12 };
const DOT_STYLE = { r: 4, fill: "#D97757", strokeWidth: 0 };
const ACTIVE_DOT_STYLE = { r: 6 };

/** Quiz score trend line — one row per attempt, oldest → newest. */
export default function QuizTrendLine({ timeline, isAr }) {
  return (
    <div className="rounded-2xl bg-white border border-border p-5 lg:col-span-8" data-testid="quiz-trend-card">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-semibold mb-1">
        <TrendingUp className="w-3.5 h-3.5 text-sage" />
        {isAr ? "تطور درجات الاختبار" : "Quiz score trend"}
      </div>
      <div className="text-xs text-muted-foreground mb-3">
        {timeline.length
          ? (isAr ? `${timeline.length} محاولة مسجلة` : `${timeline.length} attempts recorded`)
          : (isAr ? "لم تؤدّ أي اختبار بعد" : "No quiz attempts yet")}
      </div>
      <div style={{ width: "100%", height: 220 }}>
        {timeline.length ? (
          <ResponsiveContainer>
            <LineChart data={timeline} margin={LINE_MARGIN}>
              <CartesianGrid strokeDasharray="3 4" stroke={GRID_STROKE} />
              <XAxis dataKey="label" tick={AXIS_TICK_STYLE} />
              <YAxis domain={Y_DOMAIN} ticks={Y_TICKS} tick={AXIS_TICK_STYLE} />
              <Tooltip
                formatter={(v) => [`${v}%`, isAr ? "الدرجة" : "Score"]}
                labelFormatter={(l) => l}
                contentStyle={TOOLTIP_STYLE}
              />
              <Line
                type="monotone"
                dataKey="pct"
                stroke="#4A675C"
                strokeWidth={2.5}
                dot={DOT_STYLE}
                activeDot={ACTIVE_DOT_STYLE}
              />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-full flex items-center justify-center text-sm text-muted-foreground">
            {isAr ? "سيظهر الرسم هنا بعد أول اختبار" : "Your trend will appear here after your first quiz."}
          </div>
        )}
      </div>
    </div>
  );
}
